import { Component, Vue } from "vue-property-decorator";

const patientNamespace = { namespace: "patient" };
@Component({})
export default class EmergencyReferences extends Vue {
  private get _references() {
    return this.$store.getters[`${patientNamespace.namespace}/references`];
  }
  get adultReferences() {
    if (this._references) {
      return this._references.emergency;
    }
    return false;
  }

  get pedReferences() {
    if (this._references) {
      return this._references.pedemerg;
    }
    return false;
  }

  get isMissingReferences() {
    return !this.pedReferences && !this.adultReferences;
  }
}
